/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all People.
const deps = ['Person', 'Collection'];

const factory = function (Person, Collection) {
  let PersonCollection;
  return (PersonCollection = (function () {
    PersonCollection = class PersonCollection extends Collection {
      static initClass() {
        this.prototype.$id = null;
        // $resource: ''
        this.prototype.$type = Person;
      }

      $init() {
        return super.$init();
      }

      // overrides to prevent usage
      $fetch() {}
      $put() {}
      $post() {}
      $delete() {}
    };
    PersonCollection.initClass();
    return PersonCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/person').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.person', moduleDeps)
  .factory('PersonCollection', factory);
